import script from "./ContentPoliciesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentPoliciesCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b23682a2"]])

export default __exports__